import {
  Icon,
  SidebarGroup,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  Text,
} from "@salestrak/ui";
import React from "react";

import { useSidebarNav } from "../use-sidebar-nav";

/** Workflows' primary destination: All Workflows (the `workflows` roster page
 *  at `/workflows` — a List of every workflow). Mirrors TeamsNavSection. */
export function WorkflowsNavSection() {
  const { navigate, isActive } = useSidebarNav();

  return (
    <SidebarGroup>
      <SidebarMenu>
        <SidebarMenuItem>
          <SidebarMenuButton
            // Exact: a singular workflow (`/workflow/[id]`) must not light
            // this row.
            isActive={isActive("/workflows", true)}
            onClick={() => navigate("/workflows")}
          >
            <Icon name="git-branch" />
            <Text truncate>All Workflows</Text>
          </SidebarMenuButton>
        </SidebarMenuItem>
      </SidebarMenu>
    </SidebarGroup>
  );
}
